"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathValue = exports.checkSubPath = exports.checkSamePath = exports.stringifyPath = void 0;
const stringifyPath = (path) => (path.join('.'));
exports.stringifyPath = stringifyPath;
const checkSamePath = (path1, path2) => ((0, exports.stringifyPath)(path1) === (0, exports.stringifyPath)(path2));
exports.checkSamePath = checkSamePath;
const checkSubPath = (full, sub) => ((0, exports.stringifyPath)(full).startsWith((0, exports.stringifyPath)(sub)));
exports.checkSubPath = checkSubPath;
/**
 * Return undefined value if value doesn't exists.
 * Return unknown type if type unpredictable or any
 * */
const getPathValue = (value, path) => {
    const simplePath = path;
    const result = simplePath.reduce((acc, key) => {
        if (typeof acc === 'object' && acc) {
            return acc[key];
        }
        return undefined;
    }, value);
    return result;
};
exports.getPathValue = getPathValue;
//# sourceMappingURL=valuePath.js.map